<template>
  <div class="airwallex-operation">
    <a-button
      :loading="loading"
      size="large"
      type="primary"
      @click="handlePayClick"
    >
      {{ displayName }}
    </a-button>
  </div>
</template>

<script setup lang="ts">
import type { HostPaymentPage } from 'airwallex-payment-elements'
import { hpp } from './airwallex'

const props = defineProps<{
  mode: 'payment' | 'recurring'
  hostPaymentPage?: HostPaymentPage
  loading: boolean
}>()

const { $t } = useNuxtApp()

const displayName = computed(() => {
  if (props.loading) {
    return $t('chuang-jian-zhong')
  }

  return $t('qu-zhi-fu')
})

const handlePayClick = () => {
  if (props.loading) {
    return
  }
  if (props.hostPaymentPage) {
    hpp(props.mode, props.hostPaymentPage)
  }
}
</script>

<style lang="scss" scoped>
.airwallex-operation {
  display: block;
  margin: 50px auto 30px;
  > button {
    display: inline-block;
    min-width: 100px;
    margin: 0 8px;
  }
}
</style>
